import React, { Component } from "react";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import style from "./CreateRoom.module.css";
import api from "../../utils/Api";
import history from "../../utils/history";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ttmLoader from "../../assets/images/ttm-loader.gif";

import { fetchDropdownList } from "../../redux";

export class CreateRoom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      isEditLoading: false,
      pageTitle: "Create Room",
      room_id: "",
      initialValue: {
        room_name: "",
        location_id: "",
        location_address: "",
        contact_person: "",
        contact_number: "",
      },
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.setState({
        isEditMode: true,
        isEditLoading: true,
        pageTitle: "Update Room",
        room_id: this.props.match.params.id,
      });

      // call fetch room details
      this.roomDetails();
    }
  }

  roomDetails = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get("room/" + this.props.match.params.id, {
        headers: headers,
      });
      let roomDetails = response.data.data;
      this.setState({
        initialValue: {
          room_name: roomDetails.room_name,
          location_id: roomDetails.location_id,
          location_address: roomDetails.location_address,
          contact_person: roomDetails.contact_person,
          contact_number: roomDetails.contact_number,
        },
        isEditLoading: false,
      });
    } catch (error) {
      console.log("Redux error - ", error);
      this.setState({
        isEditLoading: false,
      });
    }
  };

  // Handle back button
  backHandleClick() {
    history.push("/roomlist");
  }

  render() {
    const dropDownListData = this.props.dropdownListData.dropdownList
      .lk_location;
   // console.log("dropDownListData", dropDownListData);
    return (
      <div className={style.createMainWrapper}>
        <div className="row">
          <div className="col-lg-12">
            <h3>{this.state.pageTitle}</h3>
          </div>
          <div class="col-lg-12 intro-text">
            <p class="mb-4">
            The details of rooms contained on the system may be updated here. 
            The information captured on the room will be pre-populated for amendment.
            </p>
          </div>
        </div>
        <Formik
          initialValues={this.state.initialValue}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            room_name: Yup.string().required("Room name is required"),
            location_id: Yup.string().required("Location name is required"),
            location_address: Yup.string().required(
              "Location address is required"
            ),
            contact_person: Yup.string().required("Contact person is required"),
            contact_number: Yup.string()
              .required("Contact number is required")
              .matches(/^[0-9]*$/, "Only numbers allowed")
              .matches(/^\d{10}$/, "Enter 10 digit"),
          })}
          // Post create room data to backend
          onSubmit={async (data) => {
            this.setState({
              isLoading: true,
            });
            // Payload to be sent
            const payload = {
              room_name: data.room_name,
              location_id: data.location_id,
              location_address: data.location_address,
              contact_person: data.contact_person,
              contact_number: data.contact_number,
            };

            // In edit mode
            if (this.state.isEditMode) {
              payload.room_id = this.props.match.params.id;
            }
            // Headers
            const headers = {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            };
            try {
              const response = await api.post("room", payload, {
                headers: headers,
              });
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                  successMessage: "Room created successfully!",
                });
                if (this.state.isEditMode) {
                  this.setState({
                    isLoading: false,
                    successMessage: "Room updated successfully!",
                  });
                }
              }
              setTimeout(() => {
                this.setState({
                  successMessage: "",
                });
                history.push("/roomlist");
              }, 2000);
            } catch (error) {
              if (error.response) {
                this.setState({
                  isLoading: false,
                  errorMessage: "Internal server error occured",
                });
                setTimeout(() => {
                  this.setState({
                    successMessage: "",
                  });
                }, 2000);
              }
              console.log("Crate room error", error);
            }
          }}
          render={({ errors, status, touched }) => (
            <Form>
              {this.state.isEditLoading ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} alt="loader" className={style.loading} />
                </div>
              ) : (
                <div>
                  <div className={style.createRoomWrapper}>
                    <div className="row">
                      <div className="col-md-12">
                        {/* <h4>Room Details</h4> */}
                      </div>
                    </div>

                    <div class="form-box-shadow">
                      <div className="row">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="room_name">
                             Room Name
                            <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            
                            <Field
                              name="room_name"
                              type="text"
                              id="room_name"
                              className={
                                "form-control" +
                                (errors.room_name && touched.room_name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="room_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="location_name">Location Name
                            <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              as="select"
                              name="location_id"
                              className={
                                "form-control" +
                                (errors.location_id && touched.location_id
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value="">Select location</option>
                              {dropDownListData &&
                                dropDownListData.map((element, index) => (
                                  <option
                                    key={index}
                                    value={element.lk_location_id}
                                  >
                                    {element.location_name}
                                  </option>
                                ))}
                            </Field>
                            <ErrorMessage
                              name="location_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="location_address">
                              Location Address
                              <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              name="location_address"
                              type="text"
                              id="location_address"
                              className={
                                "form-control" +
                                (errors.location_address &&
                                touched.location_address
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="location_address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3"></div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="contact_person">
                              Contact Person
                              <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              name="contact_person"
                              type="text"
                              id="contact_person"
                              className={
                                "form-control" +
                                (errors.contact_person && touched.contact_person
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="contact_person"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                          <div className="form-group">
                            <label htmlFor="contact_number">
                              Contact Number
                              <span className="mandatory">
                                <small>*</small>
                              </span>
                            </label>
                            <Field
                              name="contact_number"
                              type="text"
                              id="contact_number"
                              maxlength="10"
                              className={
                                "form-control" +
                                (errors.contact_number && touched.contact_number
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="contact_number"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3"></div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className={style.roomBtnWrapper}>
                        <Button
                          className="form-primary-btn"
                          onClick={this.backHandleClick}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" className="form-primary-btn">
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {this.state.isLoading ? (
                        <div className={style.loadingWrapper}>
                          <img src={ttmLoader} className={style.loading} />
                        </div>
                      ) : (
                        <div>
                          {this.state.successMessage && (
                            <p className={style.successMessage}>
                              {this.state.successMessage}
                            </p>
                          )}
                          {this.state.errorMessage && (
                            <p className={style.errorMessage}>
                              {this.state.errorMessage}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Form>
          )}
        />
      </div>
    );
  }
}

// export default CreateRoom;

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateRoom);
